import dayjs from 'dayjs'
import {
  getAgpOptions,
  getGluOptions,
  getMiniGluOptions,
  getMultiGluChartOptions,
  getPentagonChartOptions,
  getAreaChartOptions,
  getDayPentagonChartOptions,
  getTirOptions
} from '@/util/chart'
export default {
  data() {
    return {
      baseInfo: {},
      statisticRecord: [],
      startDate: '',
      endDate: '',
      startDateTime: '',
      endDateTime: '',
      serialNo: +new Date(),
      cgmRecord: {},
      totalPerDayCount: 288
    }
  },
  methods: {
    isVersionX() {
      return process.env.VUE_APP_VERSION === 'x'
    },
    isChinaVersion() {
      return this.$i18n.locale === 'zh'
    },
    isRussiaVersion() {
      return this.$i18n.locale === 'ru'
    },
    isTirTooLong() {
      return ['it', 'de', 'cs', 'pt', 'ru', 'fr', 'sk', 'el', 'es', 'pl'].includes(this.$i18n.locale)
    },
    isNeedConvertComma() {
      return ['cs'].includes(this.$i18n.locale)
    },
    isEmptyQueryParams(val) {
      return (!val && +val !== 0) || val === 'undefined'
    },
    isEmptyGlucose(index) {
      if (!this.cgmRecord.glucose || !this.cgmRecord.glucose[index]) {
        return false
      }
      return this.cgmRecord.glucose[index].filter((g) => !isNaN(g)).length === 0
    },
    isShowGluPercent(index) {
      if (!this.cgmRecord.glucose || !this.cgmRecord.glucose[index]) {
        return false
      }
      return this.cgmRecord.glucose[index].filter((g) => !isNaN(g)).length > 14
    },
    getStatisticData() {
      const flatArray = Array.from({ length: this.cgmRecord.glucose.length }, (_, index) => index)
      const result = []
      for (let i = 0; i < flatArray.length; i += 15) {
        // 每次取15个元素组成一组
        const group = flatArray.slice(i, i + 15)
        // 如果长度不足三个，用 null 填充
        while (group.length < 15) {
          group.push(null)
        }
        result.push(group)
      }
      return result
    },
    getToday(format) {
      format = format || 'YYYY-MM-DD HH:mm:ss'
      return dayjs().format(format)
    },
    getPercentStyle() {
      const hv = this.customizedTir.h.value
      const nv = this.customizedTir.n.value
      const lv = this.customizedTir.l.value
      const filterZero = (val, height) => (val === 0 ? 0 : height)
      if (hv >= 96) {
        return {
          n: { height: filterZero(nv, lv === 0 ? '2%' : '4%') },
          l: { height: filterZero(lv, '2%') }
        }
      } else if (lv >= 96) {
        return {
          n: { height: filterZero(nv, hv === 0 ? '100%' : '98%') },
          l: { height: lv === 100 ? '100%' : '96%' }
        }
      } else if (Number(lv) + Number(nv) >= 96) {
        return {
          n: { height: filterZero(nv, hv === 0 ? '100%' : '98%') },
          l: { height: filterZero(lv, `${lv < 2 ? 2 : lv}%`) }
        }
      }
      return {
        n: {
          height: filterZero(nv, `${Number(nv) + Number(lv)}%`)
        },
        l: { height: filterZero(lv, `${lv < 2 ? 2 : lv}%`) }
      }
    },

    getPercentLabelStyle() {
      const _hv = this.customizedTir.h.value
      const _nv = this.customizedTir.n.value
      const _lv = this.customizedTir.l.value
      const displayStyle = {
        h: _hv === 0 ? 'none' : 'block',
        n: _nv === 0 ? 'none' : 'block',
        l: _lv === 0 ? 'none' : 'block'
      }
      if (_hv >= 96) {
        return {
          h: { top: `${178 * 48 * 0.01 - 9}px`, display: displayStyle.h },
          n: {
            top: `${_lv === 0 ? 178 * 100 * 0.01 - 9 : 178 * 90 * 0.01 - 9}px`,
            display: displayStyle.n
          },
          l: { top: `${178 * 100 * 0.01 - 9}px`, display: displayStyle.l }
        }
      } else if (_nv >= 96) {
        return {
          h: { top: `${178 * 1 * 0.01 - 9}px`, display: displayStyle.h },
          n: { top: `${178 * 50 * 0.01 - 9}px`, display: displayStyle.n },
          l: { top: `${178 * 100 * 0.01 - 9}px`, display: displayStyle.l }
        }
      } else if (_lv >= 96) {
        return {
          h: { top: `${178 * 0 * 0.01 - 9}px`, display: displayStyle.h },
          n: {
            top: `${_hv === 0 ? 178 * 0 * 0.01 - 9 : 178 * 10 * 0.01 - 9}px`,
            display: displayStyle.n
          },
          l: { top: `${178 * 52 * 0.01 - 9}px`, display: displayStyle.l }
        }
      }
      const hv = 178 * _hv * 0.5 * 0.01 - 9
      let nv = 178 * (Number(_nv) / 2 + Number(_hv)) * 0.01 - 9
      const lv = 178 * (100 - Number(_lv) + Number(_lv) / 2) * 0.01 - 9
      if (nv - hv < 10) {
        nv += 10
      }
      if (lv - nv < 10) {
        nv -= 10
      }
      return {
        h: {
          top: `${hv}px`,
          display: displayStyle.h
        },
        n: {
          top: `${nv}px`,
          display: displayStyle.n
        },
        l: {
          top: `${lv}px`,
          display: displayStyle.l
        }
      }
    },
    formatterConstantComma(value, fixedNum = 1) {
      value = +value
      return Number.isInteger(value) ? value : (this.isNeedConvertComma() ? value.toFixed(fixedNum).replace('.', ',') : value.toFixed(fixedNum))
    },
    formatterIndicator(value, isConvertUnitToMg) {
      if (isNaN(value)) {
        return ''
      }
      value = isConvertUnitToMg ? Number(value) * 18 : Number(value)
      if (isConvertUnitToMg) {
        return value.toFixed()
      }
      return Number.isInteger(value) ? value : (this.isNeedConvertComma() ? value.toFixed(2).replace('.', ',') : value.toFixed(2))
    },
    // 格式化每日血糖图表右侧数据
    formatterGluRightIndicator(index, value, unit, type) {
      if (value === '') {
        return '--'
      }
      if (type === 'hour') {
        const num = this.getDayDataOverviewContent(0, index)
        return `${this.formatterIndicator(value / 100 * (num / this.totalPerDayCount) * 24)}`
      }
      return `${value}${unit}`
    },
    dataFirstPage(data = []) {
      if (data.length === 0) {
        return 0
      }
      return data[this.cgmRecord.glucose.length]
    },
    drawTirChart() {
      const el = document.getElementById('tir')
      if (!el) {
        return
      }
      const tirChart = this.$echarts.init(el, null, { renderer: 'svg' })
      const tirData = this.customizedTir
      const data = [
        { name: `${this.$t('tirChart.prettyHigh')}, ${this.formatterConstantComma(tirData.lh.value)}%`, value: tirData.lh.time, index: 0, timeStr: this.formatterConstantComma(tirData.lh.time) },
        { name: `${this.$t('tirChart.high')}, ${this.formatterConstantComma(tirData.h.value)}%`, value: tirData.h.time, index: 1, timeStr: this.formatterConstantComma(tirData.h.time) },
        { name: `${this.$t('tirChart.normal')}, ${this.formatterConstantComma(tirData.n.value)}%`, value: tirData.n.time, index: 2, timeStr: this.formatterConstantComma(tirData.n.time) },
        { name: `${this.$t('tirChart.low')}, ${this.formatterConstantComma(tirData.l.value)}%`, value: tirData.l.time, index: 3, timeStr: this.formatterConstantComma(tirData.l.time) },
        { name: `${this.$t('tirChart.prettyLow')}, ${this.formatterConstantComma(tirData.ll.value)}%`, value: tirData.ll.time, index: 4, timeStr: this.formatterConstantComma(tirData.ll.time) }
      ].filter(c => c.value !== 0)
      tirChart.setOption(
        getTirOptions(data, tirChart)
      )
      return tirChart
    },
    drawAgpChart(isMgDl = false) {
      const agpChart = this.$echarts.init(document.getElementById('agp'), null, { renderer: 'svg' })
      agpChart.setOption(
        getAgpOptions(
          this.cgmRecord.dailyPrctile10,
          this.cgmRecord.dailyPrctile25,
          this.cgmRecord.dailyPrctile50,
          this.cgmRecord.dailyPrctile75,
          this.cgmRecord.dailyPrctile90,
          isMgDl,
          this.cgmRecord.hyper,
          this.cgmRecord.hypo,
          this.isToB
        )
      )
    },
    drawMiniGluChart(isMgDl = false) {
      this.cgmRecord.glucose.forEach((item, index) => {
        const gluChart = this.$echarts.init(document.getElementById(`glu_mini_chart_${index}`), null, { renderer: 'svg' })
        gluChart.setOption(getMiniGluOptions(item, index, this.cgmRecord.beginDate, isMgDl, this.cgmRecord.hyper, this.cgmRecord.hypo))
      })
    },
    drawGluChart(isMgDl = false) {
      this.cgmRecord.glucose.forEach((item, index) => {
        const gluChart = this.$echarts.init(document.getElementById(`glu_chart_${index}`), null, { renderer: 'svg' })
        gluChart.setOption(getGluOptions(item, index, this.cgmRecord.beginDate, this.cgmRecord.eventMap, isMgDl, this.cgmRecord.hyper, this.cgmRecord.hypo, this.isToB))
      })
    },
    drawMultiGluChart(isMgDl = false) {
      const multiChart = this.$echarts.init(document.getElementById('multi_glu'), null, { renderer: 'svg' })
      multiChart.setOption(getMultiGluChartOptions(this.cgmRecord.glucose, this.cgmRecord.beginDate, isMgDl, this.isToB))
    },
    drawPentagonChart() {
      const chart = this.$echarts.init(document.getElementById('pentagon'), null, { renderer: 'svg' })
      chart.setOption(getPentagonChartOptions(this.dataFirstPage(this.cgmRecord.pentagon)))
    },
    drawAreaChart() {
      const chart = this.$echarts.init(document.getElementById('area'), null, { renderer: 'svg' })
      chart.setOption(
        getAreaChartOptions(this.cgmRecord.pentagon, this.cgmRecord.beginDate, this.cgmRecord.glucose.length)
      )
    },
    drawDayPentagonChart() {
      this.cgmRecord.pentagon.forEach((item, index) => {
        if (index < this.cgmRecord.glucose.length && !this.isEmptyGlucose(index)) {
          const chart = this.$echarts.init(document.getElementById(`day_pentagon_chart_${index}`), null, { renderer: 'svg' })
          chart.setOption(getDayPentagonChartOptions(item))
        }
      })
    },
    dateFormatter(index, format) {
      if (!this.cgmRecord.beginDate || !this.cgmRecord.endDate || index === null) {
        return ''
      }
      return dayjs(this.cgmRecord.beginDate).add(index, 'day').format(format)
    },
    perDayGluDateFormatter(index, format = 'M/D') {
      if (this.isChinaVersion()) {
        return dayjs(this.cgmRecord.beginDate).add(index, 'day').format('MM月DD日')
      }
      const enMonth = [
        this.$t('unit.JAN'),
        this.$t('unit.FEB'),
        this.$t('unit.MAR'),
        this.$t('unit.APR'),
        this.$t('unit.MAY'),
        this.$t('unit.JUN'),
        this.$t('unit.JUL'),
        this.$t('unit.AUG'),
        this.$t('unit.SEPT'),
        this.$t('unit.OCT'),
        this.$t('unit.NOV'),
        this.$t('unit.DEC')
      ]
      if (!this.cgmRecord.beginDate || !this.cgmRecord.endDate) {
        return ''
      }
      const date = dayjs(this.cgmRecord.beginDate).add(index, 'day').format(format).split('/')
      return [enMonth[date[0] - 1], date[1]]
    },
    bindGluItemChartId(index) {
      return 'glu_chart_' + index
    },
    bindMiniGluItemChartId(index) {
      return 'glu_mini_chart_' + index
    },
    bindPentagonId(index) {
      return 'day_pentagon_chart_' + index
    },
    // 五角模型模块目前只有国内版才有，暂不翻译
    getPentagonTableItem(index) {
      return [
        ['每日血糖评估', ''],
        ['葡萄糖水平在时间范围外', ''],
        ['变异系数', ''],
        ['低血糖强度', 'mg/dl*min²'],
        ['高血糖强度', 'mg/dl*min²'],
        ['平均葡萄糖值', 'mg/dl'],
        ['面积', 'mm²']
      ][index]
    },
    getPentagonTableTdContent(pIndex, index) {
      const indexMapping = ['', 'tor', 'cv', 'intHypo', 'intHyper', 'mbg', 'area']
      let val = this.cgmRecord.pentagon.slice(0, this.cgmRecord.glucose.length).map((c) => c[indexMapping[pIndex]])[
        index
      ]
      if (isNaN(val) || this.isEmptyGlucose(index)) {
        return ''
      }
      val = Number.isInteger(val) || isNaN(val) ? val : val.toFixed(1)
      if (pIndex === 1) {
        const percent = ((val / 1440) * 100).toFixed()
        val = `${val}\n(${percent}%)`
      }
      return val
    },
    getDayDataOverview(index, isMg = false) {
      if (isMg) {
        return [
          [this.$t('dailyStatistics.number')],
          [this.$t('dailyStatistics.mg.mbg'), '<118.8'],
          [this.$t('dailyStatistics.mg.sdbg'), '<25.2'],
          [this.$t('dailyStatistics.cv'), ''],
          [this.$t('dailyStatistics.mg.maxGlu'), ''],
          [this.$t('dailyStatistics.mg.minGlu'), ''],
          [this.$t('dailyStatistics.mg.lage'), '<79.2'],
          [this.$t('dailyStatistics.mg.mage'), '<70.2'],
          [this.$t('dailyStatistics.mg.gt139'), ''],
          [this.$t('dailyStatistics.mg.gt10'), ''],
          [this.$t('dailyStatistics.mg.gt78'), '<4H(17%)'],
          [this.$t('dailyStatistics.mg.lt39'), '<3H(12%)'],
          [this.$t('dailyStatistics.mg.lt28'), ''],
          [this.$t('dailyStatistics.mg.inteval3910'), ''],
          [this.$t('dailyStatistics.tirRange'), '']
        ][index]
      }
      return [
        [this.$t('dailyStatistics.number')],
        [this.$t('dailyStatistics.mbg'), '<6.6'],
        [this.$t('dailyStatistics.sdbg'), '<1.4'],
        [this.$t('dailyStatistics.cv'), ''],
        [this.$t('dailyStatistics.maxGlu'), ''],
        [this.$t('dailyStatistics.minGlu'), ''],
        [this.$t('dailyStatistics.lage'), '<4.4'],
        [this.$t('dailyStatistics.mage'), '<3.9'],
        [this.$t('dailyStatistics.gt139'), ''],
        [this.$t('dailyStatistics.gt10'), ''],
        [this.$t('dailyStatistics.gt78'), '<4H(17%)'],
        [this.$t('dailyStatistics.lt39'), '<3H(12%)'],
        [this.$t('dailyStatistics.lt28'), ''],
        [this.$t('dailyStatistics.inteval3910'), ''],
        [this.$t('dailyStatistics.tirRange'), '']
      ][index]
    },

    getDayDataOverviewContent(pIndex, index, isMg = false) {
      if (pIndex === 0) {
        return this.formatterIndicator(this.cgmRecord.num[index])
      } else if (!this.isShowGluPercent(index)) {
        return ''
      } else if (pIndex === 1) {
        return this.formatterIndicator(this.cgmRecord.mbg[index], isMg)
      } else if (pIndex === 2) {
        return this.formatterIndicator(this.cgmRecord.sdbg[index], isMg)
      } else if (pIndex === 3) {
        return this.formatterIndicator(this.cgmRecord.cv[index])
      } else if (pIndex === 4) {
        return this.formatterIndicator(this.cgmRecord.maxbg[index], isMg)
      } else if (pIndex === 5) {
        return this.formatterIndicator(this.cgmRecord.minbg[index], isMg)
      } else if (pIndex === 6) {
        return this.formatterIndicator(this.cgmRecord.lage[index], isMg)
      } else if (pIndex === 7) {
        return this.formatterIndicator(this.cgmRecord.mage[index]?.average, isMg)
      } else if (pIndex === 8) {
        return this.formatterIndicator(
          this.cgmRecord.tir.tir.map((c) => c[7] + c[6])[index]
        )
      } else if (pIndex === 9) {
        return this.formatterIndicator(
          this.cgmRecord.tir.tir.map((c) => c[7] + c[6] + c[5])[index]
        )
      } else if (pIndex === 10) {
        return this.formatterIndicator(
          this.cgmRecord.tir.tir.map((c) => c[7] + c[6] + c[5] + c[4])[index]
        )
      } else if (pIndex === 11) {
        return this.formatterIndicator(
          this.cgmRecord.tir.tir.map((c) => c[0] + c[1] + c[2])[index]
        )
      } else if (pIndex === 12) {
        return this.formatterIndicator(
          this.cgmRecord.tir.tir.map((c) => c[0])[index]
        )
      } else if (pIndex === 13) {
        return this.formatterIndicator(
          this.cgmRecord.tir.tir.map((c) => c[3] + c[4])[index]
        )
      }
    },
    tirVal(arr, isAvg = false) {
      let sum = 0
      const days = isAvg ? 1 : this.cgmRecord.glucose.length
      const totalHours = isAvg ? 24 : 24 * days * (this.dataFirstPage(this.cgmRecord.num) / (this.totalPerDayCount * days))
      arr.forEach((index) => (sum += this.dataFirstPage(this.cgmRecord.tir.tir)[index]))
      const _timeNoFormatter = totalHours * sum * 0.01
      const time = Number.isInteger(_timeNoFormatter) ? _timeNoFormatter : _timeNoFormatter.toFixed(1)
      const hour = Math.floor(time)
      const min = Math.floor((time - hour) * 60)
      const timeStr = `${this.$tc('unit.hour', hour)}${this.$tc('unit.minute', min)}`
      return {
        value: this.formatterConstantComma(sum, 2),
        time: timeStr,
        hour: isNaN(time) ? '' : this.formatterConstantComma(time)
      }
    },
    getEventMapByOffsetIndex(index) {
      if (!this.cgmRecord.eventMap || Object.keys(this.cgmRecord.eventMap).length === 0) {
        return []
      }
      return this.cgmRecord.eventMap[this.dateFormatter(index, 'YYYY-MM-DD')].slice(0, 10) || []
    },
    getEventLabel(item) {
      const unit = ''
      // if (this.isChinaVersion()) {
      //   unit = ''
      // } else {
      //   if (item.eventType === 1) {
      //     unit = 'g'
      //   } else if (item.eventType === 2) {
      //     unit = this.$t('unit.minutes')
      //   } else if (item.eventType === 3) {
      //     unit = 'U'
      //   }
      // }
      return item.eventTime.slice(11, 16) + ' ' + item.eventName + ' ' + item.eventData + unit
    }
  },
  computed: {
    patientAge() {
      if (this.baseInfo.birthday) {
        return dayjs().diff(dayjs(this.baseInfo.birthday), 'year')
      }
      return '--'
    },
    tirTimeRange() {
      if (!this.cgmRecord.tir || !this.cgmRecord.tir.tir) {
        return {
          h: { value: 0, time: 0 },
          n: { value: 0, time: 0 },
          l: { value: 0, time: 0 }
        }
      }
      const tirVal = this.dataFirstPage(this.cgmRecord.tir.tir)
      const hVal = tirVal[5] + tirVal[6] + tirVal[7]
      const nVal = tirVal[3] + tirVal[4]
      const lVal = tirVal[0] + tirVal[1] + tirVal[2]
      const hTime = 24 * hVal * 0.01
      const nTime = 24 * nVal * 0.01
      const lTime = 24 * lVal * 0.01
      return {
        h: {
          value: Number.isInteger(hVal) ? hVal : hVal.toFixed(1),
          time: Number.isInteger(hTime) ? hTime : hTime.toFixed(1)
        },
        n: {
          value: Number.isInteger(nVal) ? nVal : nVal.toFixed(1),
          time: Number.isInteger(nTime) ? nTime : nTime.toFixed(1)
        },
        l: {
          value: Number.isInteger(lVal) ? lVal : lVal.toFixed(1),
          time: Number.isInteger(lTime) ? lTime : lTime.toFixed(1)
        }
      }
    },
    customizedTir() {
      if (!this.cgmRecord.customizedTir || !this.cgmRecord.customizedTir.tir) {
        return {
          // 高
          h: { value: 0, time: 0 },
          // 正常
          n: { value: 0, time: 0 },
          // 低
          l: { value: 0, time: 0 },
          // 很高
          lh: { value: 0, time: 0 },
          // 很低
          ll: { value: 0, time: 0 }
        }
      }
      const tirVal = this.dataFirstPage(this.cgmRecord.customizedTir.tir)
      const nVal = tirVal[2]
      const hVal = tirVal[3]
      const lhVal = tirVal[4]
      const lVal = tirVal[1]
      const llVal = tirVal[0]
      const days = this.cgmRecord.glucose.length
      const totalHours = 24 * days * (this.dataFirstPage(this.cgmRecord.num) / (this.totalPerDayCount * days))
      const hTime = totalHours * (hVal.toFixed(2)) * 0.01
      const nTime = totalHours * (nVal.toFixed(2)) * 0.01
      const lTime = totalHours * (lVal.toFixed(2)) * 0.01
      const lhTime = totalHours * (lhVal.toFixed(2)) * 0.01
      const llTime = totalHours * (llVal.toFixed(2)) * 0.01
      return {
        h: {
          value: Number.isInteger(hVal) ? hVal : hVal.toFixed(2),
          time: Number.isInteger(hTime) ? hTime : hTime.toFixed(2)
        },
        n: {
          value: Number.isInteger(nVal) ? nVal : nVal.toFixed(2),
          time: Number.isInteger(nTime) ? nTime : nTime.toFixed(2)
        },
        l: {
          value: Number.isInteger(lVal) ? lVal : lVal.toFixed(2),
          time: Number.isInteger(lTime) ? lTime : lTime.toFixed(2)
        },
        lh: {
          value: Number.isInteger(lhVal) ? lhVal : lhVal.toFixed(2),
          time: Number.isInteger(lhTime) ? lhTime : lhTime.toFixed(2)
        },
        ll: {
          value: Number.isInteger(llVal) ? llVal : llVal.toFixed(2),
          time: Number.isInteger(llTime) ? llTime : llTime.toFixed(2)
        }
      }
    },
    triangleStyle() {
      const obj = {
        width: 0,
        height: 0,
        'border-top': '20px solid transparent',

        'border-bottom': '20px solid transparent',
        position: 'absolute',
        left: '60px',
        'z-index': 12
      }
      const val = +this.formatterIndicator(this.cgmRecord.lbgi)
      if (val <= 1.1) {
        obj.top = '120px'
        obj['border-left'] = '10px solid #61a311'
      } else if (val <= 2.5) {
        obj.top = '80px'
        obj['border-left'] = '10px solid #1da9ed'
      } else if (val <= 5) {
        obj.top = '40px'
        obj['border-left'] = '10px solid #f38f20'
      } else {
        obj.top = '0px'
        obj['border-left'] = '10px solid #d61a00'
      }
      return obj
    },
    lbgiHeight() {
      const val = +this.formatterIndicator(this.cgmRecord.lbgi)
      if (val <= 1.1) {
        return { top: '128px' }
      } else if (val <= 2.5) {
        return { top: '88px' }
      } else if (val <= 5) {
        return { top: '48px' }
      } else {
        return { top: '8px' }
      }
    }
  }
}
